'use strict';
import isObject from 'lodash/isObject';
import {ReduxList} from '../../../_libs/redux-observable-list/index';
import {BASE_REDUX_LIST_OPTIONS} from '../../../config/redux-list/index';
import {sortByProperty} from '../../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../../core-utilities/redux/ReduxListContainer';
import {buildPollingSyncNotifier, SYNC_PATH} from '../../../core-utilities/rx-utils/index';
import {logger} from '../logger';


/**
 * @param {Object} config
 * @param {String} config.prefix
 * @param {Function} config.getState
 * @param {String} config.parentPath
 * @param {String} config.resourcePath
 * @param {String} config.childPath
 * @param {String} config.syncNotifierParentPath
 * @return {{reduxList: ReduxList, componentOptions: ReduxListComponentOptions, isVisible: *}}
 */
export function makeReqFileList(config) {
  const {
    prefix,
    getState,
    parentPath,
    resourcePath,
    childPath,
    syncNotifierParentPath,
  } = config;

  const reduxList = new ReduxList({
    ...BASE_REDUX_LIST_OPTIONS,
    prefix,
    getState,
    pageSize: 100,
    hasParentId: true,
    useDelete: true,
    useFiltering: false,
    useAutoFilter: false,
    useFilterOptions: false,
    useSortOptions: false,
    isVisible,
    applySortOptions,
    syncNotifier: buildPollingSyncNotifier(syncNotifierParentPath, childPath, {
      pollInterval: 10000,
      pollCount: 6 * 5, // every ten seconds for 5 minutes
    }),
    listPath: parentId => `${parentPath}/${parentId}/${childPath}`,
    listSyncPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_PATH}`,
    deleteItemPath: itemId => `${resourcePath}/${itemId}`,
    logger,
  });

  const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options);

  function isVisible(file) {
    if (!isObject(file)) return false;
    return true;
  }

  return {
    reduxList,
    componentOptions,
    isVisible,
  };
}

export function applySortOptions(list) {
  return list.sort(sortByProperty('ord', true));
}



// WEBPACK FOOTER //
// ./src/js/requirements/redux/config/configReqFileList.js